import { Flex, ModalBody, Text } from '@chakra-ui/react';
import { useAccount } from 'wagmi';
import { transformAddress } from '../../utils/transformAddress';
import { CheckIcon, CopyIcon, WarningIcon } from '@chakra-ui/icons';
import { ActionButton, ActionButtonProps } from './ActionButton';
import { useCopyToClipboard } from '../../hooks/useCopyToClipboard';
import React from 'react';

type Props = {
  disconnect: () => void;
};

export const WalletModalBody = React.memo(({ disconnect }: Props) => {
  const { address } = useAccount();
  const [copiedValue, copy] = useCopyToClipboard();

  const accountAddress = address ? transformAddress(address) : '';

  const isCopiedValEqualToAddress = copiedValue === address;

  const handleCopy = (text: string) => {
    if (!isCopiedValEqualToAddress) copy(text);
  };

  const actionButtons: ActionButtonProps[] = [
    {
      Icon: isCopiedValEqualToAddress ? CheckIcon : CopyIcon,
      text: isCopiedValEqualToAddress ? 'Copied!' : 'Copy Address',
      handleClick: () => handleCopy(address as string),
    },
    {
      Icon: WarningIcon,
      text: 'Disconnect',
      handleClick: disconnect,
    },
  ];

  return (
    <ModalBody p={0} w={'100%'}>
      <Flex flexDirection={'column'} gap={'30px'} alignItems={'center'} w={'100%'}>
        <Text>{accountAddress}</Text>
        <Flex gap={'10px'} w={'100%'}>
          {actionButtons.map(({ Icon, text, handleClick }, i) => (
            <ActionButton Icon={Icon} text={text} handleClick={handleClick} key={i} />
          ))}
        </Flex>
      </Flex>
    </ModalBody>
  );
});
